import { dateFormat_DD_MM_YY } from '../../../../util/GlobalConstant';
import {
  getDataFromServer,
  getFormattedDateWithoutTimezone,
  getInDecimal
} from '../../../util';

export class AssociatedCustomersModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchAssociatedCustomers = async (payload) => {
    const { customerKey, limit, offset } = payload;

    const params = {
      limit,
      offset
    };

    const { list, totalCount } = await getDataFromServer(
      `${this.baseURL}/customers/${customerKey}/associatedCustomers`,
      this.httpHeaders,
      params
    );

    // This is where we map the raw list to customer table columns
    const customers = list.map((customer) => ({
      PRIMARY_PARTY_KEY: customer.primaryPartyKey,
      PARTY_NAME: customer.partyName,
      LINKED_PARTY_KEY: customer.linkedPartyKey,
      RELATION_DESCRIPTION: customer.relationDescription,
      SHAREHOLDER_PERCENTAGE: getInDecimal(customer.shareholderPercentage),
      SEGMENT: customer.segment,
      OCCUPATION: customer.occupation,
      RISK_RATING: getInDecimal(customer.riskRating),
      DOB_OR_INCORPORATION_DATE: getFormattedDateWithoutTimezone(
        customer.dobOrIncorporationDate,
        dateFormat_DD_MM_YY
      ),
      NATIONALITY: customer.nationality
    }));

    return {
      customers,
      totalCount
    };
  };
}
